const DEFAULT_EXPAND_OPTIONS = {
	allowInsertion: true,
	allowInteractiveExpand: true,
};

export const useExpandOptions = () => {
	return DEFAULT_EXPAND_OPTIONS;
};
